import moment from 'moment';

/**
 * Tarih formatlama utilities
 */

/**
 * Tarih string'ini DD.MM.YYYY HH:mm formatında formatlar
 */
export const formatDate = (dateString) => {
  if (!dateString) return '-';
  return moment(dateString).format('DD.MM.YYYY HH:mm');
};

/**
 * Tarih string'ini sadece DD.MM.YYYY formatında formatlar
 */
export const formatDateOnly = (dateString) => {
  if (!dateString) return '-';
  return moment(dateString).format('DD.MM.YYYY');
};

/**
 * Tarih string'ini sadece HH:mm formatında formatlar
 */
export const formatTimeOnly = (dateString) => {
  if (!dateString) return '-';
  return moment(dateString).format('HH:mm');
};

/**
 * Tarihin ne kadar önce olduğunu döndürür (örn: 2 saat önce)
 */
export const formatRelativeTime = (dateString) => {
  if (!dateString) return '-';
  return moment(dateString).fromNow();
};

/**
 * İki tarih arasındaki farkı gün olarak döndürür
 */
export const getDaysBetween = (startDate, endDate) => {
  if (!startDate || !endDate) return 0;
  const start = moment(startDate);
  const end = moment(endDate);
  return end.diff(start, 'days');
};

/**
 * Tarih string'ini ISO formatına çevirir
 */
export const toISOString = (dateString) => {
  if (!dateString) return null;
  return moment(dateString).toISOString();
};

/**
 * Bugünün tarihini DD.MM.YYYY formatında döndürür
 */
export const getCurrentDate = () => {
  return moment().format('DD.MM.YYYY');
};

/**
 * Şu anki zamanı HH:mm formatında döndürür
 */
export const getCurrentTime = () => {
  return moment().format('HH:mm');
};

/**
 * Form başlığından baş harfleri alır
 */
export const getFormInitials = (formTitle) => {
  if (!formTitle) return 'F';
  const words = formTitle.split(' ');
  if (words.length === 1) return words[0].charAt(0).toUpperCase();
  return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
};

/**
 * Rastgele renk döndürür
 */
export const getRandomColor = () => {
  const colors = ['#3B82F6', '#8B5CF6', '#EC4899', '#F59E0B', '#10B981', '#6366F1'];
  return colors[Math.floor(Math.random() * colors.length)];
};

/**
 * Durum rengini döndürür
 */
export const getStatusColor = (isActive) => {
  return isActive ? '#34D399' : '#F87171';
};
